"use client";

import { useTheme } from "next-themes";
import { Toaster as Sonner, ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  const context = useTheme();
  const theme = (context.theme || "system") as ToasterProps["theme"];

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        className: "!gap-2 w-full lg:!w-96 !rounded-lg",
        actionButtonStyle: {
          height: "28px",
          borderRadius: "8px",
          paddingLeft: "10px",
          paddingRight: "10px",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
